/** 
 * 1 premium features
 * 2 force login
 * 
 * */
import { START_SHARE_DOC } from 'Components/viewer/ui/constants/collaboration.constants';

class PermissionManager{
  constructor(){
    this.premiumFeatures = [];
    //this.forceLoginFeatures = [];
    this.notLoginFeatures = [];
    this.onlineFeatures = [];
    this.groups = {
      // key: []
    };
    this.CNJPPremiumFeatures=[];

    this.premiumFeatures.push(START_SHARE_DOC)
  }
  /**
   * @param {Array} list
   */
  registerPremiumFeatures(list){
    //!初始化高级功能列表
    this.premiumFeatures.push(...list);
    //this.forceLoginFeatures.push(...list);
  }
  registerOnlineFeatures(list){
    this.onlineFeatures.push(...list);
    //this.forceLoginFeatures.push(...list);
  }
  registerCNJPPremiumFeatures(list){
    this.CNJPPremiumFeatures.push(...list);
  }
/*
  registerForceLoginFeatures(list){
    this.forceLoginFeatures.push(...list);
  }
*/
  registerNotLoginFeatures(list){
    this.notLoginFeatures.push(...list);
  }
  resigterFeaturesGroup(groupKey, list){
    groupKey = groupKey.toUpperCase();
    this.groups[groupKey] = list;
  }
  // isInGroup('PDF2Office', xxx)
  isSupportFeature(groupKey, feature){
    groupKey = groupKey.toUpperCase();
    let group = this.groups[groupKey];
    if(group && group.indexOf(feature) !== -1){
      return true;
    }
    return false;
  }

  hasGroup(groupKey){
    groupKey = groupKey.toUpperCase();
    let group = this.groups[groupKey];
    if(!!group){
      return true;
    }
    return false;
  }

  isPremiumFeature(key){
    let val = this.premiumFeatures.indexOf(key) !== -1;
    return val;
  }
  isCNJPPremiumFeature(btnName){
    return this.CNJPPremiumFeatures.includes(btnName);
  }
  isOnlineFeature(key){
    let val = this.onlineFeatures.indexOf(key) !== -1;
    return val;
  }
  isForceLoginFeature(key){
    //let val = this.forceLoginFeatures.indexOf(key) !== -1;
    let val = this.notLoginFeatures.indexOf(key) === -1;
    return val;
  }

  getTimeStamp() {
    let timestamp = new Date().getTime();
    return timestamp;
  }
  getTimeStampByPastDay() {
    let timestamp = new Date().getTime() - 1000*3600*24;
    return timestamp;
  }
  getTrialFirstInfo(){
    let info = {usedTimes:1, timestamp: this.getTimeStamp()};
    return info;
  }

  diffTime(startDate,endDate) {
    let diff = (endDate - startDate);
    if ( diff <0 )
        return "00:00:01";
    // day
    // let days=Math.floor(diff/(24*3600*1000));

    // hour
    let leave1=diff%(24*3600*1000);
    let hours=Math.floor(leave1/(3600*1000));
    if (hours < 10){
        hours = "0" + hours;
    }
    // min
    let leave2=leave1%(3600*1000);
    let minutes=Math.floor(leave2/(60*1000));
    if (minutes < 10){
        minutes = "0" + minutes;
    }
    // second
    let leave3=leave2%(60*1000);
    let seconds=Math.round(leave3/1000);
    if (seconds < 10){
        seconds = "0" + seconds;
    }

    let diffValue = hours + ":"+ minutes + ":" + seconds;
    return diffValue;
  }
  getWaitingTime(timestamp, now, duration) {
    let last = timestamp + duration ;
    if ( (last - now) <0 )
        return "00:00:00";
    let diff = this.diffTime(now, last);
    return diff;
  }

  calcPermissionForSpecial(permisson){
    const {duration, times} = permisson;
    if(duration === 0){
      switch (times) {
        case 0:
          return {permissonDetail:{permisson, isAllowed: false, forbit: true}};
        case -1:
          return {permissonDetail:{permisson, isAllowed: true}};
        case -2:
          return {permissonDetail:{permisson, isAllowed: false, hide: true}};
        default:
          break;
      }
    }
    return null;
  }

  calcPermission(permisson, dashboardTrialInfo){
    // duration (second)
    const {duration, times, name} = permisson;
    let isUpdatedTrialInfo = false;
    let permissonDetail = null;

    // special number
    let result = this.calcPermissionForSpecial(permisson);
    if(!!result){
      return result;
    }

    do {
      let count = (duration*10/3600>>>0) *0.1;
      if( count < 0.1 ) count = 0.1;
      let remainingTime = '00:00:00';
  
      let info = dashboardTrialInfo[name];
      if(!info){
          // inital data
          isUpdatedTrialInfo = true;
          dashboardTrialInfo[name] = info = {usedTimes:0, timestamp: this.getTimeStampByPastDay()};
      }
      let now = this.getTimeStamp();
      let last = info.timestamp;
      let diff = (now - last)/1000;// /3600
      if (diff > duration){
        permissonDetail = {permisson, isAllowed: true, times, remainingTime, count};
        break;
      }
  
      if (info.usedTimes >= times){
          remainingTime = this.getWaitingTime(last, now, duration*1000);
          permissonDetail = {permisson, isAllowed: false, times, remainingTime, count};
          break;
      }

      permissonDetail = {permisson, isAllowed: true, times, remainingTime, count};
    } while (false);

    return {permissonDetail, dashboardTrialInfo, isUpdatedTrialInfo};
  }
  /**
   *
   *
   * @param {*} permisson
   * @param {*} dashboardTrialInfo
   * @returns {{timestamp:Number, usedTimes:Number}}
   */
  updateUserTrialInfo(permisson, dashboardTrialInfo){
    // duration (second)
    const {duration, /* times, */ name} = permisson;
    let info = null;//{timestamp, usedTimes}
    if(dashboardTrialInfo && dashboardTrialInfo[name]){
        info = dashboardTrialInfo[name];
        // in one hour
        let now = this.getTimeStamp();
        let last = info.timestamp;
        let diff = (now - last)/1000/3600;
        if (diff > 1*duration/3600){
            info.usedTimes = 0;
            info.timestamp = now;
        }
        if (info.usedTimes === 0)
            info.timestamp = now;
        info.usedTimes += 1;
    }else{
        info = this.getTrialFirstInfo()
    }
    return info;
  }
}

const permissionManager = new PermissionManager();
window.__permissionManager__ = permissionManager;

export {
  permissionManager
}